import axios from 'axios';

export default {
    FETCH_GIFTS ({commit, dispatch}){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.get('hybridGifting')
                .then((response) => {
                    const { data: { data } } = response;
                    localStorage.setItem('gifts', JSON.stringify(data));
                    commit('SET_GIFTS', data);
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },

    GET_SELECTED_GIFT ({ commit }, id) {
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.get(`/hybridGifting/${id}`)
                .then((response) => {
                    commit('TOGGLE_LOADING', false);
                    const { data: { data } } = response;
                    commit('SET_SELECTED_GIFT', data && data[0]);
                    console.log('SET_SELECTED_GIFT data ', data && data[0]);
                    resolve(data && data[0]);
                })
                .catch((error) => {
                    commit('TOGGLE_LOADING', false);
                    console.log('GET_SELECTED_PLAN error ', error);
                    reject(error);
                });
        })
    },

    // UPDATE_GIFT({commit, dispatch}, payload){
    //     return new Promise((resolve, reject) => {
    //         commit('TOGGLE_LOADING', true);
    //
    //
    //         return axios.put(`/gifts`, payload)
    //             .then((response) => {
    //                 commit('TOGGLE_LOADING', false);
    //                 const { data: { data } } = response;
    //                 console.log('UPDATE_EXPERT response ', response);
    //                 resolve(data);
    //             })
    //             .catch((error) => {
    //                 commit('TOGGLE_LOADING', false);
    //                 console.log('UPDATE_EXPERT error ', error);
    //                 reject(error);
    //             })
    //     })
    // },

  ADD_GIFT({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      return axios.post(`/hybridGifting`, payload)
        .then((response) => {
          commit('TOGGLE_LOADING', false);
          const { data: { data } } = response;
          console.log('ADD_GIFT response ', response);
          resolve(data);
        })
        .catch((error) => {
          commit('TOGGLE_LOADING', false);
          console.log('ADD_GIFT error ', error);
          reject(error);
        })
    })
  },
  UPDATE_HYBRID_GIFT({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      return axios.post(`/hybridGifting/updCorporationGift`, payload)
        .then((response) => {
          commit('TOGGLE_LOADING', false);
          const { data: { data } } = response;
          console.log('EDIT_GIFT response ', response);
          resolve(data);
        })
        .catch((error) => {
          commit('TOGGLE_LOADING', false);
          console.log('EDIT_GIFT error ', error);
          reject(error);
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/gifts/actions.js